import { empty } from '@convincely/utils/lib/strings.js';
import { writable } from '../library.js';
/**
 * @param {*} initValue
 * @param {?object} initProps
 * @return {Array.<Writable<string>|Writable<{}>|function(...[*]=)>}
 */
export function setIconFactory(initValue = empty, initProps = {}) {
    const icon_src = writable(initValue);
    const icon_props = writable(initProps);
    return [icon_src, icon_props, function (src, props) {
            icon_src.set(src);
            if (props) {
                icon_props.set(props);
            }
        }];
}
export function increment(n) {
    return n + 1;
}
export function incrementSkip(n) {
    return n + 2;
}
export function decrement(n) {
    return n - 1;
}
//# sourceMappingURL=utls.js.map